export default "__VITE_ASSET__DDf_m0dR__"